import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, Chip, Grid } from "@mui/material";
import FormField from "components/FormField";
import beveragesList from "./beveragesList";

const BeveragesPicker = ({
  values,
  touched,
  errors,
  formField,
  setFieldValue,
  showComponent = false,
}) => {
  const { beverages } = formField;

  // Create mapping from value to label for display
  const beverageLabelMap = beveragesList.reduce(
    (acc, beverage) => ({
      ...acc,
      [beverage.value]: beverage.label,
    }),
    {}
  );

  if (!showComponent) return null;

  return (
    <Grid size={{ xs: 12 }} my={2}>
      <Autocomplete
        multiple
        freeSolo
        disableCloseOnSelect
        options={beveragesList.map((option) => option.value)}
        getOptionLabel={(option) => option}
        value={values[beverages.name] || []}
        onChange={(event, newValue) => {
          setFieldValue(beverages.name, newValue);
        }}
        renderTags={(value, getTagProps) =>
          value.map((optionValue, index) => (
            <Chip
              key={index}
              label={beverageLabelMap[optionValue] || optionValue}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <FormField
            {...params}
            label={beverages.label}
            name={beverages.name}
            placeholder={beverages.placeholder}
            onChange={() => null}
            error={touched[beverages.name] && Boolean(errors[beverages.name])}
          />
        )}
      />
    </Grid>
  );
};

BeveragesPicker.propTypes = {
  values: PropTypes.instanceOf(Object).isRequired,
  touched: PropTypes.instanceOf(Object).isRequired,
  errors: PropTypes.instanceOf(Object).isRequired,
  formField: PropTypes.instanceOf(Object).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  showComponent: PropTypes.bool,
};

export default BeveragesPicker;
